var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 14.403C5.68664 14.403 7.74654 14.9703 9.52381 16.1039V1.54022C7.72122 0.513057 5.65495 0 3.33333 0C3.07034 0 2.85714 0.214948 2.85714 0.4801V13.9229C2.85714 14.188 3.07034 14.403 3.33333 14.403Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 0C14.3643 0 12.2981 0.514864 10.4762 1.54505V16.1053C12.2712 14.9705 14.3312 14.403 16.6667 14.403C16.9297 14.403 17.1429 14.188 17.1429 13.9229V0.4801C17.1429 0.214948 16.9297 0 16.6667 0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90476 2.84211V13.7233C1.90476 14.5106 2.54435 15.1488 3.33333 15.1488C5.09561 15.1488 6.66593 15.4848 8.06068 16.1563C6.95376 16.2315 6.06555 16.3839 5.13234 16.6325C4.95977 16.6784 4.41847 16.8436 3.74973 17.0477C2.70443 17.3667 1.34766 17.7808 0.600981 17.9831C0.298176 18.0652 0 17.8377 0 17.5246V5.17039C0 4.02099 0.817981 3.06223 1.90476 2.84211Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0952 13.7233V2.84211C19.182 3.06223 20 4.02099 20 5.17039V17.5246C20 17.8377 19.7018 18.0652 19.399 17.9831C18.6523 17.7808 17.2957 17.3668 16.2504 17.0478C15.5816 16.8437 15.0402 16.6784 14.8677 16.6325C13.9369 16.3845 13.0509 16.2323 11.948 16.1569C13.3519 15.4848 14.9194 15.1488 16.6667 15.1488C17.4556 15.1488 18.0952 14.5106 18.0952 13.7233Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.e5c9f9ffdba97503acd629c4fcce8ef3.svg";
export { ForwardRef as ReactComponent };